/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface Instaxchange
 */
export class Instaxchange {
    /**
     *
     * @type {string}
     * @memberof Instaxchange
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof Instaxchange
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof Instaxchange
     */
    type: string;
    /**
     *
     * @type {boolean}
     * @memberof Instaxchange
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Instaxchange
     */
    autoApprove: boolean;
    /**
     *
     * @type {string}
     * @memberof Instaxchange
     */
    accountRefId: string;
    /**
     *
     * @type {string}
     * @memberof Instaxchange
     */
    secretKey: string;
    /**
     *
     * @type {string}
     * @memberof Instaxchange
     */
    targetAddress: string;
    /**
     *
     * @type {string}
     * @memberof Instaxchange
     */
    targetCurrency: string;
    /**
     *
     * @type {string}
     * @memberof Instaxchange
     */
    fromCurrency: string;
    /**
     *
     * @type {boolean}
     * @memberof Instaxchange
     */
    amountFromDB: boolean;
}
